import React, { useState, useEffect } from "react";
import styled from "styled-components";

function BurningDesire() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setVisible(true);
    }, 100);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <Wrapper className={visible ? "fade-in" : ""}>
      <LeftRow>
        <TitleArea>
          <H1Sizer aria-hidden="true">THE BURNING DESIRE IN A DOLLAR BILL</H1Sizer>
          <H1>THE BURNING DESIRE IN A DOLLAR BILL</H1>
        </TitleArea>
        <Info>
          <PBold>Video (SD) . 2017 . 5:06</PBold>
          <PBold>
            Distributed by the Canadian Filmmakers Distribution Centre
          </PBold>
        </Info>
        <Details>
          <p>
            The Burning Desire in a Dollar Bill shows how the special interests
            of media conglomerates and their parent companies mould our latent
            desires at a young age, later leaving us confused as to whether we
            are lusting after the sexually charged imagery or the products being
            advertised. The film argues that the act of purchasing is the
            strongest aphrodisiac in a capitalist society, leaving open the
            possibility that a solution to toppling capitalism is to shift our
            sexual desires from consumerism to political action.
          </p>
          <p>
            The film was created during a residency at Signal Culture using a
            modified Paik-Abe Raster Manipulation Unit. A running VHS tape was
            manipulated using a voltage-controlled eurorack modular synthesizer,
            allowing the object of desire to be distorted, picked apart, and
            reveal its true form of capitalist allure.
          </p>

          <p>
            Audio mixing, editing, and additional processing by Nick Maturo. For
            screening consideration please email info [at] bleunuitvideo [dot]
            com.
          </p>
        </Details>
      </LeftRow>
      <RightRow>
        <Iframe
          title="vimeo-player"
          src="https://player.vimeo.com/video/227320062?h=f95db349bc"
          allowFullScreen
        />
        <Img
          src="/images/art-portfolio/burningdesire/burningdesire-01.gif"
          alt="The Burning Desire in a Dollar Bill"
        />
      </RightRow>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  /* flex-direction: column; */
  gap: 40px;
  margin-top: 20px;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  &.fade-in {
    opacity: 1;
  }
  @media screen and (max-width: 1024px) {
    flex-direction: column;
  }
  @media screen and (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

const LeftRow = styled.div`
  display: flex;
  flex-direction: column;
`;

const Info = styled.div`
  margin-top: 5px;
  /* margin-bottom: 15px; */
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleArea = styled.div`
  display: grid;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
`;

/* Invisible copy that reserves layout height for the scaled title */
const H1Sizer = styled.h1`
  grid-area: 1 / 1;
  visibility: hidden;
  font-size: 5em;
  line-height: calc(1.1em * 2.5);
  margin: 0;
  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

const H1 = styled.h1`
  grid-area: 1 / 1;
  align-self: start;
  font-size: 5em;
  line-height: 1.1;
  margin: 0;

  transform: scale(1, 2.5);
  -webkit-transform: scale(1, 2.5);
  -moz-transform: scale(1, 2);
  -o-transform: scale(1, 2);
  /* Anchor at top so the scale grows downward instead of into the header */
  transform-origin: top left;
  @media screen and (max-width: 1024px) {
    font-size: 3.5em;
    line-height: 1.05;
    margin-top: 1em;
    margin-bottom: 0;

    transform: none;
    -webkit-transform: none;
    -moz-transform: none;
    -o-transform: none;
    transform-origin: initial;
  }
  @media screen and (max-width: 768px) {
    font-size: 4em;
    margin-top: 1em;
    margin-bottom: 0;

    transform: none;
    -webkit-transform: none;
    -moz-transform: none;
    -o-transform: none;
    transform-origin: none;
  }
`;

const PBold = styled.p`
  /* margin-bottom: -20px; */
  font-size: 1.5em;
  font-weight: bold;
`;

const RightRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  align-items: center;
  gap: 50px;
  @media screen and (max-width: 1024px) {
    width: 100%;
    margin: auto;
  }
  @media screen and (max-width: 768px) {
    margin: auto;
    width: 100%;
  }
`;

const Iframe = styled.iframe`
  width: 640px;
  height: 360px;
  aspect-ratio: 16 / 9;
  border: 0;
  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;

const Img = styled.img`
  width: 480px;
  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;

export default BurningDesire;
